import cx from 'classnames'
import {ReactComponent as CircleIcon} from 'icons/circle.svg'
import {ReactComponent as MinusIcon} from 'icons/minus.svg'
import {ReactComponent as PlusIcon} from 'icons/plus.svg'

type Props = {
  type: 'plus' | 'minus'
  disabled: boolean
  onClick: () => void
}

export const Button = ({type, disabled, onClick}: Props) => {
  return (
    <div className={cx('relative', disabled ? 'text-gray-2' : 'hover:text-theme')}>
      <CircleIcon />
      <div
        className={cx(
          'absolute w-full h-full flex items-center justify-center top-0 left-0',
          disabled ? 'text-gray-2 pointer-events-none' : 'cursor-pointer'
        )}
        onClick={onClick}
      >
        {type === 'plus' ? <PlusIcon /> : <MinusIcon />}
      </div>
    </div>
  )
}
